// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "./application"

import GeneralController from "./general_controller"
application.register("general", GeneralController)

import RellaxController from "./rellax_controller"
application.register("rellax", RellaxController)

import AccodionController from "./accordion_controller"
application.register("accordion", AccodionController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import PillarrankingController from "./pillarranking_controller"
application.register("pillarranking", PillarrankingController)

import NestedForm from "stimulus-rails-nested-form"
application.register("nested-form", NestedForm)

import FieldController from "./field_controller"
application.register("field", FieldController)

// Extending NestedForm Component with FieldController that way I can add different field types.
application.register("nested-form-field", FieldController)

import Carousel from "stimulus-carousel"
application.register("carousel", Carousel)

import RedactorXController from "./redactorx_controller"
application.register("redactorx", RedactorXController)

import PillarGoalsSelectionController from "./pillar_goals_selection_controller"
application.register("pillar-goals-selection", PillarGoalsSelectionController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import MediaController from "./media_controller"
application.register("media", MediaController)

import CheckboxSelectAll from "stimulus-checkbox-select-all"
application.register("checkbox-select-all", CheckboxSelectAll)

import Flatpickr from "stimulus-flatpickr"
application.register("flatpickr", Flatpickr)

import DocumentUserActions from "./document_user_actions_controller"
application.register("document-user-actions", DocumentUserActions)

import Notification from "./notification_controller"
application.register("notification", Notification)

// Commented out after removing pay wall
// import PaymentIntent from "./payment_intent_controller"
// application.register("payment-intent", PaymentIntent)

import Search from "./search_controller"
application.register("search", Search)

import SearchAttendee from "./search_attendee_controller"
application.register("search-attendee", SearchAttendee)

import InfiniteScroll from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScroll)

import Plan from "./plan_controller"
application.register("plan", Plan)

import Share from "./share_controller"
application.register("share", Share)

import Clipboard from "./clipboard_controller"
application.register("clipboard", Clipboard)

import Modal from "./modal_controller"
application.register("modal", Modal)

import ScrollTo from "stimulus-scroll-to"
application.register('scroll-to', ScrollTo)

import ExpertForm from "./expert_form_controller"
application.register("expert-form", ExpertForm)

import ContactForm from "./contact_form_controller"
application.register("contact-form", ContactForm)

import Colcade from "./colcade_controller"
application.register("colcade", Colcade)
